const INITIAL_STATE = {
  country: '',
  language: ''
};

const Region = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_REGION':
      return action.payload;
    case 'SET_LANGUAGE':
      return { ...state, language: action.payload };
    case 'SET_COUNTRY':
      return { ...state, country: action.payload };
    default:
      return state;
  }
};

export default Region;
